/* tslint:disable */
/* eslint-disable */
/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Count
 * @export
 * @interface ApplicationsCount
 */
export interface ApplicationsCount {
    /**
     * 
     * @type {number}
     * @memberof ApplicationsCount
     */
    count?: number;
}

export function ApplicationsCountFromJSON(json: any): ApplicationsCount {
    return ApplicationsCountFromJSONTyped(json, false);
}

export function ApplicationsCountFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicationsCount {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': !exists(json, 'count') ? undefined : json['count'],
    };
}

export function ApplicationsCountToJSON(value?: ApplicationsCount | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
    };
}


